import { Button, Card, Stack, TextField, Typography } from "@mui/material";
import { useState } from "react";

import useDowloadCredential from "./useDownloadCredential";

// ----------------------------------------------------------------------

export default function AdminDownloadCredentials() {
	const [credential, setCredential] = useState("");

	const { onDownload } = useDowloadCredential();

	return (
		<Card sx={{ p: 3, mt: 3 }}>
			<Typography sx={{ mb: 2 }} variant='h6'>
				{"Descargar zip connectionID"}
			</Typography>

			<Stack flexDirection={"row"} alignItems='center'>
				<TextField
					label={"Añadir connectionID"}
					onChange={(e) => setCredential(e.target.value)}
					placeholder={"Añade una connectionID"}
					value={credential}
					sx={{ minWidth: 320 }}
				/>
				<Button sx={{ ml: 4 }} variant='contained' onClick={() => onDownload(credential)}>
					{"Descargar"}
				</Button>
			</Stack>
		</Card>
	);
}
